exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.card-status-center[data-v-65273a8a]{\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n#queueSelect[data-v-65273a8a]{\n  width: 200px !important\n}\n", ""]);

// exports
